import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';

import Loading from '../../../lib/components/Loading';

// const Dashboard = Loadable({
//   loader: () => import('../containers/DashboardContainer'),
//   loading: Loading,
// });
const MyPages = Loadable({
  loader: () => import('../containers/MyPagesContainer'),
  loading: Loading,
});
const NewBankAccount = Loadable({
  loader: () => import('../components/Billing/NewBankAccount'),
  loading: Loading,
});
// const NewSubscription = Loadable({
//   loader: () => import('../components/Subscription/NewSubscription'),
//   loading: Loading,
// });
// const EditSubscription = Loadable({
//   loader: () => import('../components/Subscription/EditSubscription'),
//   loading: Loading,
// });
// const EditSubscriptionConfirm = Loadable({
//   loader: () => import('../components/Subscription/EditSubscriptionConfirm'),
//   loading: Loading,
// });
// const NewSubscriptionConfirm = Loadable({
//   loader: () => import('../components/Subscription/NewSubscriptionConfirm'),
//   loading: Loading,
// });
// const EditProgram = Loadable({
//   loader: () => import('../containers/Program/EditProgramContainer'),
//   loading: Loading,
// });
// const Registrants = Loadable({
//   loader: () => import('../containers/RegistrantsContainer'),
//   loading: Loading,
// });
const Downloads = Loadable({
  loader: () => import('../containers/DownloadsContainer'),
  loading: Loading,
});
// const Referral = Loadable({
//   loader: () => import('../components/Referral/Referral'),
//   loading: Loading,
// });

const Routes = ({ props }) => (
  <Switch>
    {/* <Route
      path="/admin/dashboard"
      exact
      render={(routeProps) => <Dashboard {...routeProps} {...props} />}
    /> */}
    <Route
      path="/admin/pages"
      render={routeProps => <MyPages {...routeProps} {...props} />}
    />
    <Route
      path="/admin/billing/bank/new"
      render={routeProps => <NewBankAccount {...routeProps} {...props} />}
    />
    {/* <Route
      path="/admin/subscription/new"
      exact
      render={routeProps => <NewSubscription {...routeProps} {...props} />}
    />
    <Route
      path="/admin/subscription/new/confirm"
      exact
      render={routeProps => (
        <NewSubscriptionConfirm {...routeProps} {...props} />
      )}
    /> */}
    {/* <Route
      path="/admin/subscription/edit"
      exact
      render={routeProps => <EditSubscription {...routeProps} {...props} />}
    />
    <Route
      path="/admin/subscription/edit/confirm"
      exact
      render={routeProps => (
        <EditSubscriptionConfirm {...routeProps} {...props} />
      )}
    /> */}
    {/* <Route
      path="/admin/programs/:id/edit"
      render={routeProps => <EditProgram {...routeProps} {...props} />}
    /> */}
    {/* <Route
      path="/admin/programs/:program_id/registrants"
      render={routeProps => <Registrants {...routeProps} {...props} />}
    /> */}
    <Route
      path="/admin/downloads"
      render={routeProps => <Downloads {...routeProps} {...props} />}
    />
    {/* <Route
      path="/admin/refer"
      render={routeProps => <Referral {...routeProps} {...props} />}
    /> */}
  </Switch>
);
Routes.propTypes = {
  props: PropTypes.object,
};
export default Routes;
